const links = [
  {
    title: "Réparation de volet",
    desc: "Volet en panne ? Sangle, cordon, moteur ou télécommande : nous réparons tous les types de volets.",
    href: "/reparation-volet-roulant",
    icon: "ri-tools-line",
  },
  {
    title: "Dépannage urgence",
    desc: "Volet bloqué ou coincé en urgence ? Intervention rapide à Strasbourg et dans le Bas-Rhin.",
    href: "/depannage-urgence",
    icon: "ri-alarm-warning-line",
  },
  {
    title: "Tarifs",
    desc: "Diagnostic et déplacement gratuits. Prix clairs annoncés avant toute intervention.",
    href: "/tarifs",
    icon: "ri-file-list-3-line",
  },
];

export default function Maillage() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold text-center mb-3">
          Vous cherchez une autre prestation ?
        </h2>
        <p className="text-[#2F4A63] text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Nous intervenons aussi sur ces services. Découvrez nos autres solutions pour votre volet roulant.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {links.map((link) => (
            <a
              key={link.title}
              href={link.href}
              className="group bg-[#F5F2EB] rounded-xl border border-[#E2E8F0] p-5 md:p-6 hover:border-[#E8734A]/40 transition-colors flex flex-col"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#E8734A]/10 mb-4">
                <i className={`${link.icon} text-[#E8734A] text-lg`}></i>
              </div>
              <h3 className="text-[#1B2A4A] text-base font-bold mb-2 group-hover:text-[#E8734A] transition-colors">
                {link.title}
              </h3>
              <p className="text-[#2F4A63] text-sm leading-relaxed">{link.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}